import { Button, ButtonProps } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface AsyncButtonProps extends ButtonProps {
  label: string;
  loadingLabel?: string;
  labelClassName?: string;
  icon?: React.ReactNode;
  loadingIcon?: React.ReactNode;
  loading?: boolean;
  as?: React.ElementType;
}

export default function AsyncButton({
  loading,
  label,
  loadingLabel,
  labelClassName,
  loadingIcon,
  as,
  icon,
  ...props
}: AsyncButtonProps) {
  const Component = as || Button;
  return (
    <Component {...props} disabled={loading || props.disabled}>
      {loading
        ? loadingIcon || <Loader2 className="mr-2 h-4 w-4 animate-spin" />
        : icon}
      <span className={labelClassName}>
        {loading ? loadingLabel || label : label}
      </span>
    </Component>
  );
}
